import { useMutation, useQueryClient } from '@tanstack/react-query'

import { useAlerts } from '../../../theme/hooks/useAlerts'
import { updateContactpersoonForEntity } from '../services/updateContactpersoonForEntity'

import { queryKey as queryKeyContactpersonen } from './useContactpersonenForEntity'

export { usePatchContactpersoonForEntity }

const usePatchContactpersoonForEntity = () => {
  const queryClient = useQueryClient()
  const { successAlert } = useAlerts()

  return useMutation({
    mutationFn: updateContactpersoonForEntity,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKeyContactpersonen] })
      successAlert('Contactpersoon aangepast')
    },
  })
}
